// extracted by mini-css-extract-plugin
export default {"imageSuggestionForm":"styles_imageSuggestionForm__5cl4M"};